export const isValidOffer = (offer) => {
  return !!offer?.id;
};
export function mapHomeOffer(offer) {
  return {
    href: offer?.href,
    ...offer
  };
}
